﻿(function ($) {

    $('.Form__NavigationBar__Action.btnNext').on('click', function(){
        var step = parseFloat($(this).closest('.EPiServerForms').find('[data-f-type="step"]:visible').attr('data-f-stepindex')) + 1;

        window.dataLayer.push({
            'event': 'rlEpiserverFormNextButton',
            'step': step
        });
    });

    $('.Form__NavigationBar__Action.btnPrev').on('click', function(){
        var step = parseFloat($(this).closest('.EPiServerForms').find('[data-f-type="step"]:visible').attr('data-f-stepindex')) + 1;

        window.dataLayer.push({
            'event': 'rlEpiserverFormPrevButton',
            'step': step
        });
    });

}(jQuery));